import e from"styled-components";import{theme as i}from"../../../theme.js";const o=e.div`
  background-color: ${i.colors.primary[500]};
  .wrapper {
    box-sizing: border-box;
    padding: ${i.spacing*6}px 0;
    width: ${i.maxWidth};
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      display: flex;
      align-items: center;
      gap: ${i.spacing*4}px;
    }
    .logo {
      > img {
        object-fit: contain;        
        width: 160px;
        height: 40px;
      }
      > svg {
        width: 160px;
        height: 40px;
        > g, path {
          fill: ${i.colors.shades[0]};
        }
      }
    }
    .links {
      display: flex;
    }
  }
  .rights {
    color: ${i.colors.shades[0]};
    font-size: 14px;
    &--mobile {
      display: none;
    }
  }
  @media screen and (max-width: ${i.breakpoints.xl}) {
    .wrapper {
      width: 100%;
      padding: ${i.spacing*6}px ${i.spacing*2}px;
      .logo {
        display: flex;
        flex-direction: column;
      }
    }
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    .wrapper {
      flex-direction: column;
      gap: ${i.spacing*4}px;
      .rights {
        &--desktop {
          display: none;
        }
        &--mobile {
          display: block;
        }
      }
      .links {
        flex-direction: column;
      }
    }
  }
`;export{o as Container};
